import React,{useEffect} from 'react';
import './Landing.css'
import {Link} from 'react-router-dom'
import ChatPlugin from './ChatPlugin';
import Carousel from '../../Carousel/Carousel'
import HomeCarousel from './Home_Carousel';


function Landing() {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  
  return (
    <>
      <HomeCarousel />
      {/* <div className='landing-page'>

        

         <div className='landing-page-animation'>
          <img src="https://image.freepik.com/free-vector/people-analyzing-growth-charts_23-2148866843.jpg" alt="logo" width="100%" />
        </div>
        <div className='landing-page-content'>
          <h1 className='landing-title'>Enhance The Eminence Within</h1>
          <div>Strategic Links' employee appraisal tools give information driven insights to recruit and shape the perfect candidates. Take your business to the next level with simple, quick and scientifically validated tests that are easy on the pockets and build a progressive, nurturing and rewarding enterprise</div>

          <Link to="/tests-login">
            <div className='landing-page-button'>
              Get started
            </div>
          </Link>
        </div> 
      </div> */}

      
      {/* <ChatPlugin /> */}
    </>
  );
}

export default Landing;
